/// <reference path='../_all.ts' />

module tabs {
  'use strict';



  var isVisible = (elem : HTMLElement) : boolean => {
    var rect :ClientRect;

    if ( !elem ) {
        return false;
    }

    rect = elem.getBoundingClientRect();

    // Make sure element is not hidden (display: none) or disconnected
    return (rect.width > 0 || rect.height > 0 || elem.getClientRects().length > 0);
  }

  

  /**
   *
   */
  tabs.$inject = [
    '$timeout', 
    '$window', 
    'anchorNavService', 
    'pageMetaService', 
    'parallaxService', 
    'debounce',
  ];
  export function tabs(
    $timeout :ng.ITimeoutService
    , $window : ng.IWindowService
    , anchorNavService : navigation.IAnchorNavService
    , pageMetaService: navigation.IPageMetaService
    , parallaxService : navigation.IParallaxService
    , debounce:  navigation.IDebounceService): ng.IDirective {
    
    return {
      restrict: 'A',
      scope: {
        toggleMode: '@',
        scroll: '@',
        autoCollapse: '@',
      },
      controller: TabCtrl,
      link: function (scope : ITabScope, element : ng.IAugmentedJQuery, attr, controller : TabCtrl) {
        scope.meta = pageMetaService.getPageMeta;

        var activeIndex : number = -1;

        var pagesRoot : ng.IAugmentedJQuery = angular.element(element.children()[1]);

        controller.setToggleMode(!!scope.toggleMode);

        controller.onChange((oldTab : TabItem, newTab : TabItem) => {
          if (oldTab == newTab) return;
          if (newTab) {
            pagesRoot.addClass("active");
          } else {
            pagesRoot.removeClass("active");
          }
          
          //animate direction
          element.removeClass("anim-to-right");
          element.removeClass("anim-to-left");
          if (newTab && oldTab && oldTab.index > newTab.index) {
            element.addClass("anim-to-right");
          } else {
            element.addClass("anim-to-left");
          }
          
          //if activated content not visible, scroll so that the end is visible or the head is on top of the screen - header with.
          if (scope.scroll && !oldTab && newTab) { //there was no tab selected before
            var el : JQuery = $(element);
            var topPos = el.offset().top
              - parseInt(el.css("border-top-width"))
              - parseInt(el.css("margin-top"));

            $timeout(() => {              
              (<any>$).smoothScroll(Math.round(topPos - $(".pagehead").height()))
            }, 100);
          }

        })

        //autoCollapse for footer: tab will deactivate if we scroll up
        if (scope.autoCollapse) {

          var el : JQuery = $(element);
        
          var onScroll = (event: ng.IAngularEvent, scrollTop : number) => {
            if (!controller.getActiveTab()) return;
            var topPos = el.offset().top
                        - parseInt(el.css("border-top-width"))
                        - parseInt(el.css("margin-top"));

            if (topPos > (scrollTop + $(window).height())) {
              anchorNavService.setInactive(controller.getActiveTab().navItem);
              controller.toggleActive(controller.getActiveTab());
            }
          };
          
          onScroll = debounce(onScroll, 2000, false);
          parallaxService.subscribeOnScroll(scope, onScroll);          
        }


        //set tab state according to url.
        var setActiveTab = (path : string)  => {
          angular.forEach(controller.tabs, (t, index) => {

            if (!t.navItem) return;

            if (t.navItem.compareKey(path)) {
              controller.toggleActive(t, true);
              return;
            }

            if (anchorNavService.search()) {
              if (t.navItem.compareQuery(anchorNavService.search())) {
                //this is it? so wow
                controller.toggleActive(t, true);
                return;
              } else if (t.navItem.compareQuery(anchorNavService.search(), true)) {
                //this is parent of active?
                controller.toggleActive(t, true); 
                return;
              }
            }
          });
        };
        setActiveTab(anchorNavService.getRequestLocalRelativePathPart());

        scope.$on('$locationChangeSuccess', (ev: ng.IAngularEvent, newUrl : string, oldUrl : string, newState : string, oldState : string) => {
          if (newUrl == oldUrl) return;
          if (angular.equals({}, anchorNavService.search())) return;
          setActiveTab(anchorNavService.getLocalRelativePathPart());
        });
        

        //no active index from url: set first tab active
        if (!scope.toggleMode) {
          if (!controller.getActiveTab()) controller.toggleActiveIndex(0);
        }
        
      }
    }
  }
}